<template>
  <v-row>
    <v-col class="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-4 mx-auto">
      <ValidationObserver ref="form" v-slot="{ invalid }">
        <v-form @submit.prevent="save" autocomplete="off">
          <v-card>
            <v-card-title>
              <v-icon large left>mdi-account-box</v-icon>
              <span class="title">Meu perfil</span>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col class="text-center">
                  <v-avatar color="secondary" size="100">
                    <v-img v-if="avatar" :src="avatar" :alt="form.name" class="avatar" />
                    <v-img
                      v-else-if="user.avatar"
                      :src="user.avatar"
                      :alt="form.name"
                      class="avatar"
                    />
                    <span
                      v-else
                      class="white--text headline"
                      style="font-size: 30px!important"
                    >{{ form.name ? form.name[0] : '' }}</span>
                  </v-avatar>
                </v-col>
              </v-row>
              <v-row>
                <v-col v-if="!avatar" class="text-center">
                  <v-btn
                    @click="openImageGetter"
                    small
                    outlined
                    color="primary"
                    style="margin-top: -15px"
                  >Alterar foto</v-btn>
                </v-col>
                <v-col v-else class="text-center">
                  <v-btn
                    @click="avatar = null"
                    small
                    outlined
                    style="margin-top: -15px"
                    class="mr-1"
                    color="grey darken-1"
                    :disabled="loading_avatar"
                  >
                    <v-icon small left>mdi-refresh</v-icon>Resetar
                  </v-btn>
                  <v-btn
                    @click="updateImage"
                    small
                    color="primary"
                    style="margin-top: -15px"
                    class="mr-1"
                    :loading="loading_avatar"
                  >
                    <v-icon small left>mdi-arrow-up</v-icon>Enviar
                  </v-btn>
                </v-col>
              </v-row>
              <input
                @change="changeAvatar($event)"
                type="file"
                name
                id
                ref="avatar"
                v-show="false"
                accept="image/*"
              />
              <ValidationProvider name="nome" rules="required" v-slot="{ errors }">
                <v-text-field
                  label="Nome Completo"
                  name="nome"
                  type="text"
                  v-model="form.name"
                  :error-messages="errors"
                  :disabled="form_loading"
                />
              </ValidationProvider>
              <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                <v-text-field
                  label="Email"
                  name="email"
                  type="email"
                  :value="user.email"
                  :error-messages="errors"
                  disabled
                />
              </ValidationProvider>
              <ValidationProvider name="senha atual" :rules="'required'" v-slot="{ errors }">
                <v-text-field
                  label="Senha atual"
                  name="senha_atual"
                  v-model="form.senha_atual"
                  :error-messages="errors"
                  :disabled="form_loading"
                  :type="show2 ? 'text' : 'password'"
                  :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show2 = !show2"
                  autocomplete="off"
                />
              </ValidationProvider>
              <ValidationProvider name="senha" :rules="form.id ? '' : 'min:6'" v-slot="{ errors }">
                <v-text-field
                  id="password"
                  label="Nova Senha"
                  name="senha"
                  v-model="form.senha"
                  :error-messages="errors"
                  :disabled="form_loading"
                  :type="show ? 'text' : 'password'"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show = !show"
                  :hint="'Deixe em branco para não alterar'"
                  autocomplete="off"
                />
              </ValidationProvider>
            </v-card-text>
            <v-card-actions>
              <v-btn type="submit" :loading="form_loading" color="primary">SALVAR</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </ValidationObserver>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    form: {},
    form_loading: false,
    show: false,
    show2: false,
    avatar: null,
    avatar_file: null,
    loading_avatar: false
  }),
  methods: {
    save() {
      this.$refs.form.validate().then(v => {
        if (v) {
          this.form_loading = true;
          let payload = {
            name: this.form.name,
            old_password: this.form.senha_atual
          };
          if (this.form.senha != "") {
            payload.password = this.form.senha;
          }

          this.$http
            .post("/profile", payload)
            .then(r => {
              this.form_loading = false;
              this.$store.dispatch("login", { user: r.data.user });
              this.$store.commit("sendMessage", {
                text: "Perfil atualizado com sucesso!",
                color: "success"
              });
              this.$router.push("/");
            })
            .catch(e => {
              this.form_loading = false;
              this.$store.commit("sendMessage", {
                text: e.response.data.message,
                color: "red"
              });
            });
        }
      });
    },
    updateImage() {
      this.loading_avatar = true;
      let data = new FormData();
      data.append("avatar", this.avatar_file);

      this.$http.post("/profile/avatar", data).then(
        r => {
          this.loading_avatar = false;
          this.avatar = null;
          this.$store.commit("setUser", r.data.user);
          this.$store.commit("sendMessage", {
            text: "Avatar atualizado com sucesso!",
            color: "success"
          });
        },
        e => {
          this.loading_avatar = false;
          alert(e.response.data.message);
        }
      );
    },
    openImageGetter() {
      this.$refs.avatar.click();
    },
    changeAvatar(event) {
      this.avatar = this.getUrlPreview(event.target.files[0]);
      this.avatar_file = event.target.files[0];
    },
    getUrlPreview(image) {
      return URL.createObjectURL(image);
    }
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    }
  },
  created() {
    this.form = { ...this.user };
    this.form.senha = "";
  }
};
</script>

<style lang="scss">
.avatar {
  -webkit-box-shadow: inset 0px 0px 56px -10px rgba(0, 0, 0, 0.43);
  -moz-box-shadow: inset 0px 0px 56px -10px rgba(0, 0, 0, 0.43);
  box-shadow: inset 0px 0px 56px -10px rgba(0, 0, 0, 0.43) !important;
}
</style>